<template>
  <v-dialog
    lazy
    persistent
    v-model="alert"
    max-width="50%"
  >
    <v-card>
      <v-card-title :class="`title ${themeColor} white--text`">
        <v-icon
          large
          dark
        >{{icon}}</v-icon> {{title}}
      </v-card-title>

      <v-card-text
        class="text-xs-center"
        v-html="text"
      >
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="close()"
        ><v-icon class="mr-2">mdi-check</v-icon>ตกลง
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AlertBox',
  data () {
    return {
      alert: false,
      title: '',
      text: '',
      typeAlertBox: '',
      resolve: null
    }
  },
  computed: {
    themeColor () {
      if (this.typeAlertBox === 'success') return this.typeAlertBox
      if (this.typeAlertBox === 'info') return 'primary'
      if (this.typeAlertBox === 'warning') return this.typeAlertBox
      if (this.typeAlertBox === 'error') return this.typeAlertBox

      return 'success'
    },
    icon () {
      if (this.typeAlertBox === 'success') return 'check_circle'
      if (this.typeAlertBox === 'info') return 'info'
      if (this.typeAlertBox === 'warning') return 'warning'
      if (this.typeAlertBox === 'error') return 'error'

      return 'check_circle'
    }
  },
  methods: {
    close () {
      this.resolve({ status: 'close' })
      this.alert = false
    },
    showAlert (text, typeAlertBox = null, title = null) {
      this.title = title || ''
      this.text = text
      this.typeAlertBox = typeAlertBox || 'success'
      this.alert = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    }
  }
}
</script>
